import type { MailAdminDomainDetail, MailAdminMailbox, MailRouteDraft } from './api';
// @ts-expect-error Direct Node strip-types tests require the source extension.
import { mailboxesForDomain, mailboxDisplayName } from './mailbox-editor-helpers.ts';
// @ts-expect-error Direct Node strip-types tests require the source extension.
import { catchAllMailboxIds } from './mailbox-addresses.ts';

/** Compare domain membership, never a filtered or paginated mailbox response. */
export function pendingDomainMailboxes(
  draft: MailRouteDraft | null,
  active: MailAdminDomainDetail | null,
  query: string
): MailAdminMailbox[] {
  if (!draft || !active) return [];
  const activeIds = new Set([
    ...active.addresses.map((route) => route.mailbox),
    ...active.aliases.map((route) => route.mailbox),
    ...catchAllMailboxIds(active)
  ]);
  const search = query.trim().toLowerCase();
  return mailboxesForDomain(draft, active.domain).filter((mailbox) =>
    !activeIds.has(mailbox.id) && (!search || [
      mailboxDisplayName(mailbox, draft), mailbox.primaryEmail, mailbox.description
    ].some((value) => value?.toLowerCase().includes(search)))
  );
}
